import { Box, Typography } from '@mui/material';
import CondensedProductCard from '../../components/CondensedProductCard';
import ButtonLink from '../../components/ButtonLink';

export default function ProductsList({ room, productsByRating, buildOnClick }) {
  return (
    <Box display="flex" flexDirection="column">
      <Typography variant="h3" fontWeight={600} mb={0.5} sx={{ textTransform: 'capitalize' }}>
        Shop Top-Rated {room.category.name}
      </Typography>
      <Typography mb={3}>
        Browse the best-reviewed products available in the Energy Action Guide.
      </Typography>

      <Box
        mb={2}
        display="flex"
        flexDirection={{ xs: 'column', sm: 'row' }}
        justifyContent="space-between"
        alignItems={{ xs: 'center', sm: 'stretch' }}
        overflow={{ xs: 'scroll', md: 'auto' }}
      >
        {productsByRating.map((product) => (
          <Box key={product.id} minWidth={{ xs: 255, md: 'auto' }} maxWidth={400} flex={1}>
            <CondensedProductCard product={product} onClick={buildOnClick(product.id)} />
          </Box>
        ))}
      </Box>

      <ButtonLink
        external
        href={`/products/${room.category.handle}`}
        variant="primary"
        sx={{
          alignSelf: 'flex-start',
          textTransform: 'none',
          fontWeight: 700,
          fontSize: '0.875rem',
          width: { xs: '100%', sm: 'auto' },
        }}
      >
        Shop all {room.category.name}
      </ButtonLink>
    </Box>
  );
}
